/**
 * Created by user on 2020/5/29.
 */

import tableCn2TwDebugTable from './table_cn2tw.debug.safe.json';
import { ITable } from '../types';

export = tableCn2TwDebugTable as any as ITable
